import { makeAutoObservable } from 'mobx'
import { apiClient } from '../../service/ApiClient'
import { CreateIssueDTO, EndIssueDTO, Issue } from '../../types/models/Issue'
import { CreateOrderDTO, EndOrderDTO, Order } from '../../types/models/Order'
import { User } from '../../types/models/User'
import { CreateApiKeyDTO } from '../dto/createApi.dto'

export class UserAction {
  currentPath: string | null | undefined
  isFilterCurrentPath = false
  audioOn

  issues: undefined | Issue[]
  orders: undefined | Order[]
  users: undefined | User[]

  constructor() {
    this.audioOn = !localStorage.getItem('audio')
    makeAutoObservable(this)
  }

  setCurrentPath(path: string | null) {
    this.currentPath = path
  }

  setFilterCurrentPath(bool: boolean) {
    this.isFilterCurrentPath = bool
  }

  async getDevice(id: string | number) {
    const { data } = await apiClient.get(`/devices/${id}`)

    return data
  }

  async switchDevice(id: string | number) {
    const { data } = await apiClient.get(`/devices/switch/${id}`)

    return data
  }

  async getIssue(start?: Date | null, end?: Date | null) {
    const { data } = await apiClient.get(`/issue`, {
      params: {
        startTs: start,
        endTs: end,
      },
    })

    return data
  }

  async getNewIssue() {
//    const { data } = await apiClient.get('/issue/new')
    const { data } = await apiClient.get(encodeURI('/issue/new_by_source/Авария'))
    this.issues = data
    return data
  }

  async getNewIssueBySource(source: string) {
    const { data } = await apiClient.get(encodeURI(`/issue/new_by_source/${source}`))
    this.issues = data
    return data
  }

  async getNewIssueByDevice(id: string | number) {
    const { data } = await apiClient.get(encodeURI(`/issue/new_by_device/${id}`))

    return data
  }
  
  async getNewOrders() {
    const { data } = await apiClient.get(encodeURI('/issue/new_by_source/Заказ'))
    this.orders = data
    return data
  }

  async getUsers() {
    try {
      const { data } = await apiClient.get('/users')
      this.users = data
      return data
    } catch (error) {
      setTimeout(() => {
        this.getUsers()
      }, 3000)
    }
  }

  async getCurrentUsers(location: string) {
    try {
      const { data } = await apiClient.get(`/users/allOf/${location}`)
      this.users = data
      return data
    } catch (error) {
      setTimeout(() => {
        this.getCurrentUsers(location)
      }, 3000)
    }
  }

  async createIssue(dto: CreateIssueDTO) {
    const { data } = await apiClient.post('/issue', dto)
    this.getNewIssue()
    return data
  }

  async createOrder(dto: CreateOrderDTO) {
    const { data } = await apiClient.post('/issue', dto)
    this.getNewOrders()
    return data
  }

  async acceptIssue(id: string | number) {
    const { data } = await apiClient.get(`/issue/${id}/accept`)
    this.getNewIssue()
    return data
  }

  async acceptOrder(id: string | number) {
    const { data } = await apiClient.get(`/issue/${id}/accept_order`)
    this.getNewIssue()
    return data
  }

  async compliteIssue(id: string | number) {
    const { data } = await apiClient.get(`/issue/${id}/complite`)
    this.getNewIssue()
    return data
  }

  async completeOrder(id: string | number) {
    const { data } = await apiClient.get(`/issue/${id}/complete_order`)
    this.getNewIssue()
    return data
  }

  async endIssue(id: string | number, dto: EndIssueDTO) {
    const { data } = await apiClient.post(`/issue/${id}/end`, dto)
    this.getNewIssue()
    return data
  }

  async endOrder(id: string | number, dto: EndIssueDTO) {
    const { data } = await apiClient.post(`/issue/${id}/end_order`, dto)
    this.getNewIssue()
    return data
  }

  async setMuteAudio(boolean: boolean) {
    this.audioOn = boolean
    boolean
      ? localStorage.removeItem('audio')
      : localStorage.setItem('audio', 'on')
  }

  async editIssueComment(id: number | string, value: string) {
    const { data } = await apiClient.put(`/issue/${id}`, { comment: value })

    return data
  }

  async editIssueFeedback(id: number | string, value: string) {
    const { data } = await apiClient.put(`/issue/${id}`, { feedback: value })

    return data
  }

  async deleteIssue(id: number | string) {
    const { data } = await apiClient.delete(`/issue/${id}`)
    this.getNewIssue()
    return data
  }

  async CreateApiKey(dto: CreateApiKeyDTO) {
    const { data } = await apiClient.post(`/users/apiKey`, dto)
    return data
  }
}
